import * as Yup from 'yup';
import { AccountContactType } from '../../../../../../shared/types/modules/account';

export const initialValues: AccountContactType = {
    typeContactPerson: '',
    isClient: false,
    acceptsHabeasData: false,
};

export const validationSchema = Yup.object({
    typeContactPerson: Yup.string().required(
        'El tipo de persona contacto es obligatorio'
    ),
});
